module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4c04f0198c7c4910c95d5dc814024c7f.png";